import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    button: {
        position: 'relative'
    },
    buttonLoader: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-12px',
        marginLeft: '-12px'
    }
};

const LoaderButton = ({
    classes,
    isLoading,
    text,
    loadingText,
    className = '',
    disabled = false,
    ...props
}) => (
    <Button
        className={`LoaderButton ${classes.button} ${className}`}
        disabled={disabled || isLoading}
        {...props}
    >
        {isLoading && (
            <CircularProgress className={classes.buttonLoader} size={24} />
        )}
        {!isLoading ? text : loadingText}
    </Button>
);

LoaderButton.propTypes = {
    classes: PropTypes.shape().isRequired,
    isLoading: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    loadingText: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool
};

LoaderButton.defaultProps = {
    className: '',
    disabled: false
};

export default withStyles(styles)(LoaderButton);
